import { BillStatusEnum } from "src/api/generated/models/Digiwork/MaitreD/Domen/Model/bill-status-enum";
import { EmployeeDto } from "src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto";
import { GroupDto } from "src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/group-dto";
import { TableDto } from "src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/table-dto";

export class BillSearchModel {
    billNumber?: number;
    from?: Date;
    until?: Date;
    groups?: Array<GroupDto>;
    tables: Array<string>;
    waiters: Array<EmployeeDto>;
    billStatuses: Array<BillStatusEnum>;
  }